import React from 'react';

const Education = ({ language }) => {
  const translations = {
    de: {
      education_title: "Ausbildung & Qualifikationen",
      education_subtitle: "Fundierte akademische Informatik-Ausbildung kombiniert mit fortdauernder Spezialisierung in IT-Sicherheit.",
      
      master_title: "Master of Science (MSc) in IT Security",
      master_inst: "FH Campus Wien",
      master_badge: "Laufend • Berufsbegleitend",
      master_desc: "Vertiefung in fortgeschrittene Informationssicherheit und offensive wie defensive Methoden. Konzipiert für Berufstätige mit intensivem Fokus auf praxisrelevante Security-Architekturen.",
      master_topics: ["Penetration Testing & Exploit Analysis", "Incident Response & Forensik", "Cloud & Infrastructure Security", "Advanced Cryptography & Network Security"],

      bachelor_title: "Bachelor of Science (BSc) in Computer Science & Digital Communications",
      bachelor_inst: "FH Campus Wien",
      bachelor_badge: "Erfolgreich abgeschlossen",
      bachelor_desc: "Breit gefächerte Kernausbildung in Software- und Systementwicklung, Rechnernetzen sowie digitaler Kommunikation mit zahlreichen Gruppen- und Praxisprojekten.",
      bachelor_topics: ["Software Engineering & OOP", "Rechnernetze & Netzwerkarchitekturen", "Betriebssysteme & Linux Administration", "Datenbanken & Web Development"],

      cert_section_title: "Zertifizierungen & Praxisausbildung",
      certs: [
        {
          name: "CISCO Ethical Hacker",
          issuer: "Cisco Networking Academy",
          status: "Zertifiziert",
          link: "https://www.credly.com/badges/360877f7-0b60-4166-b685-922264944013/linked_in_profile"
        },
        {
          name: "HTB CPTS (Certified Penetration Testing Specialist)",
          issuer: "Hack The Box Academy",
          status: "In Vorbereitung / Laufend",
          link: null
        }
      ]
    },
    en: {
      education_title: "Education & Qualifications",
      education_subtitle: "Solid academic foundations in computer science combined with continuous specialization in IT security.",

      master_title: "Master of Science (MSc) in IT Security",
      master_inst: "FH Campus Wien (University of Applied Sciences)",
      master_badge: "Ongoing • Part-Time Evening",
      master_desc: "In-depth specialization in advanced cybersecurity, offensive and defensive security methods. Tailored for working professionals with a strong focus on real-world security architectures.",
      master_topics: ["Penetration Testing & Exploit Analysis", "Incident Response & Forensics", "Cloud & Infrastructure Security", "Advanced Cryptography & Network Security"],

      bachelor_title: "Bachelor of Science (BSc) in Computer Science & Digital Communications",
      bachelor_inst: "FH Campus Wien (University of Applied Sciences)",
      bachelor_badge: "Graduated",
      bachelor_desc: "Comprehensive core education in software and systems engineering, computer networking, and digital communications through numerous practical group projects.",
      bachelor_topics: ["Software Engineering & OOP", "Computer Networks & Architectures", "Operating Systems & Linux Administration", "Databases & Web Development"],

      cert_section_title: "Certifications & Practical Training",
      certs: [
        {
          name: "CISCO Ethical Hacker",
          issuer: "Cisco Networking Academy",
          status: "Certified",
          link: "https://www.credly.com/badges/360877f7-0b60-4166-b685-922264944013/linked_in_profile"
        },
        {
          name: "HTB CPTS (Certified Penetration Testing Specialist)",
          issuer: "Hack The Box Academy",
          status: "In Progress",
          link: null
        }
      ]
    }
  };

  const t = translations[language];

  return (
    <>
      <h2>{t.education_title}</h2>
      <p style={{ maxWidth: '44rem', marginBottom: '2rem' }}>{t.education_subtitle}</p>

      <div className="education-grid">
        <div className="education-card">
          <div className="card-header-row">
            <span className="edu-degree-badge">MSc</span>
            <span className="edu-status-badge active">{t.master_badge}</span>
          </div>
          <h3>{t.master_title}</h3>
          <p className="edu-inst">{t.master_inst}</p>
          <p className="edu-desc">{t.master_desc}</p>
          <div className="edu-topics">
            {t.master_topics.map((topic, i) => (
              <span key={i} className="edu-topic-pill">{topic}</span>
            ))}
          </div>
        </div>

        <div className="education-card">
          <div className="card-header-row">
            <span className="edu-degree-badge completed">BSc</span>
            <span className="edu-status-badge">{t.bachelor_badge}</span>
          </div>
          <h3>{t.bachelor_title}</h3>
          <p className="edu-inst">{t.bachelor_inst}</p>
          <p className="edu-desc">{t.bachelor_desc}</p>
          <div className="edu-topics">
            {t.bachelor_topics.map((topic, i) => (
              <span key={i} className="edu-topic-pill">{topic}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="edu-cert-strip">
        <h4>{t.cert_section_title}</h4>
        <div className="edu-cert-list">
          {t.certs.map((cert, i) => (
            <div key={i} className="cert-item-card">
              <div className="cert-info">
                <strong>{cert.name}</strong>
                <span>{cert.issuer}</span>
              </div>
              <div className="cert-action">
                <span className="cert-status-tag">{cert.status}</span>
                {cert.link && (
                  <a href={cert.link} target="_blank" rel="noopener noreferrer" className="cert-verify-link">
                    Credly &rarr;
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Education;